import * as React from 'react';
import styled from 'styled-components';

import { color } from 'styles/utils';

const UnstyledHorizon = ({ children, ...props }) =>
  children ? (
    <div {...props}>
      <div>{children}</div>
    </div>
  ) : (
    <div role="presentation" {...props}>
      <div></div>
    </div>
  );

const Horizon = styled(UnstyledHorizon)`
  --height: clamp(12rem, 15vw, 50rem);

  min-block-size: clamp(3rem, 20vw, 5rem);
  pointer-events: none;
  position: relative;

  &::after {
    background: ${color('darkestTeal')};
    content: '';
    height: 4rem;
    left: 0;
    position: absolute;
    top: var(--height);
    width: 100%;
  }

  & > * {
    block-size: var(--height);
    filter: drop-shadow(0 -4rem 3rem rgb(35 106 145 / 70%));
    inline-size: 100%;
    left: 0;
    position: absolute;
    top: 0;
  }

  & > *::before,
  & > *::after {
    block-size: 100%;
    clip-path: ellipse(calc(60% + 15vw) min(50vw, 250%) at 50% min(50vw, 250%));
    content: '';
    inline-size: 100%;
    left: 0;
    position: absolute;
    top: 0;
  }

  & > *::before {
    background-image: linear-gradient(
        90deg,
        transparent 25%,
        ${color('lightestTeal')},
        transparent 75%
      ),
      linear-gradient(${color('mediumTeal')}, ${color('darkestTeal')});
    top: -2px;
  }

  & > *::after {
    background-image: linear-gradient(
      ${color('darkTeal')},
      ${color('darkestTeal')}
    );
  }
`;

export default Horizon;
